export default __webpack_public_path__ + "media/zurb/img/icons/hamburger-icon-57f958b866bfee849011cff99f0e7f80.svg";